import flagList from '@/plugins/tools/flag-currency-svg'
export default {
  // 获取多页面的url
  $viewUrl() {
    const loc = window.location
    const href = loc.href
    const url = encodeURIComponent(href) // 编码转换
    return url
  },
  // 窗口宽度
  $width() {
    let winWidth = null
    if (window.innerWidth) {
      winWidth = window.innerWidth
    } else if (document.body && document.body.clientWidth) {
      winWidth = document.body.clientWidth
    }
    return winWidth
  },
  // 窗口高度
  $height() {
    let winHeight = null
    if (window.innerHeight) {
      winHeight = window.innerHeight
    } else if (document.body && document.body.clientHeight) {
      winHeight = document.body.clientHeight
    }
    return winHeight
  },
  // 判断是否为移动端
  isMobile() {
    return !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)
  },
  // 过滤器
  $filters() {
    return this.$options.filters
  },
  getFlagIconName() {
    return (currency) => {
      const ret = flagList.find(item => {
        return item.currency === currency
      })
      if (ret && ret.flag) {
        return ret.flag
      } else {
        return 'FlagOther'
      }
    }
  },

  payLinkIsOldPage() {
    return window.sessionStorage.getItem('payment-link-page-version') === 'old';
  },
}
